import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-well',
  styleUrl: 'well.css',
  shadow: false,
})
export class Well {
  @Prop() type: string = "blue";

  render() {
    return (
      <div class={`well ${this.type}`}>
        <slot />
      </div>
    );
  }
}
